__webpack_require__.hmrF = function() { return "clock." + __webpack_require__.h() + ".hot-update.json"; };